/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { GetStoreReportQuery } from '../../models/get-store-report-query';
import { GetStoreReportQueryResult } from '../../models/get-store-report-query-result';

export interface ApiNurseryManagerReportsGetStoreReportPost$Params {
      body?: GetStoreReportQuery
}

export function apiNurseryManagerReportsGetStoreReportPost(http: HttpClient, rootUrl: string, params?: ApiNurseryManagerReportsGetStoreReportPost$Params, context?: HttpContext): Observable<StrictHttpResponse<GetStoreReportQueryResult>> {
  const rb = new RequestBuilder(rootUrl, apiNurseryManagerReportsGetStoreReportPost.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<GetStoreReportQueryResult>;
    })
  );
}

apiNurseryManagerReportsGetStoreReportPost.PATH = '/api/NurseryManager/Reports/GetStoreReport';
